export const minimumNumberOfShares = 1;
export const minimumDinarValue = 10;
export const maximumDinarValue = 999;
export const maximumCount = 1000;
export const minimumOrder = 1; 
export const maximumTargetAmount = 500000; 
export const maxCivilDigits = 10;  
export const minDate = '01/01/1920';